import AOS from "aos";
//import 'aos/dist/aos.css';

document.addEventListener("DOMContentLoaded", function () {
  AOS.init({
    offset: 0,
  });
  // if (document.getElementsByClassName("splide").length != 0) {
  //   var splide = new Splide(".splide", {
  //     type: "loop",
  //     perPage: 4,
  //     pagination: false,
  //     breakpoints: {
  //       1024: {
  //         perPage: 1,
  //       },
  //     },
  //     autoplay: true,
  //   });
  //   splide.mount();
  // }

  //changing the meny bar
  let options = {
    //root: null, //document.querySelector("#main-menu"),
    rootMargin: "0px",
    threshold: [0.3],
  };

  let observer = new IntersectionObserver(callback, options);

  // let targets = document.querySelectorAll(".growing-line");
  // for (var target of targets) {
  //   //console.log("observe: ", target);
  //   observer.observe(target);
  // }

  let sp_main = document.querySelector("#sp-main");
  if (sp_main) {
    observer.observe(sp_main);
  }
  let sp_page = document.querySelector("#sp-page");
  if (sp_page) {
    observer.observe(sp_page);
  }
  let sp_process = document.querySelector("#sp-process");
  if (sp_process) {
    observer.observe(sp_process);
  }
  let sp_portfolio_single = document.querySelector(
    "#sp-porfolio-single-header"
  );
  if (sp_portfolio_single) {
    observer.observe(sp_portfolio_single);
  }

  //second faster observer
  let optionsFast = {
    //root: null, //document.querySelector("#main-menu"),
    rootMargin: "0px",
    threshold: [0.95],
  };

  let observerFast = new IntersectionObserver(callbackFast, optionsFast);

  let sp_mainFast = document.querySelector("#sp-main");
  if (sp_mainFast) {
    observerFast.observe(sp_mainFast);
  }
  let sp_pageFast = document.querySelector("#sp-page");
  if (sp_pageFast) {
    observerFast.observe(sp_pageFast);
  }
  let sp_processFast = document.querySelector("#sp-process");
  if (sp_processFast) {
    observerFast.observe(sp_processFast);
  }
  let sp_portfolio_singleFast = document.querySelector(
    "#sp-porfolio-single-header"
  );
  if (sp_portfolio_singleFast) {
    observerFast.observe(sp_portfolio_singleFast);
  }

  //observer.observe(document.querySelector("#tradycja"));

  jQuery(".navbar-burger").on("click", menu_selected);
  jQuery(".navbar-menu").on("click", menu_selected);
  jQuery(".sp-add-to-cart").on("click", sp_add_to_cart);

  // required to refresh woocommerce notices for OceanWP ajax add to cart.
  jQuery("body").on("added_to_cart", function (e) {
    //console.log(e);
    //alert('added'+e);
  });
});

const menu_selected = (event) => {
  const hamburger = jQuery(event.currentTarget).hasClass("navbar-burger");
  const nav = jQuery(".navbar-menu");
  const kids = jQuery(".navbar-burger").children();
  //console.log("menu_selected");
  if (nav.hasClass("-translate-y-full")) {
    if (hamburger) {
      nav.removeClass("-translate-y-full").addClass("translate-y-0");
      kids.each(function (i) {
        const className = "line" + (i + 1);
        jQuery(this).addClass(className);
      });
    }
  } else {
    nav.removeClass("translate-y-0").addClass("-translate-y-full");
    kids.each(function (i) {
      const className = "line" + (i + 1);
      jQuery(this).removeClass(className);
    });
  }
};

let callback = (entries, observer) => {
  entries.forEach((entry) => {
    //console.log("callback;", entry.target);
    if (entry.isIntersecting) {
      switch (entry.target.id) {
        case "logo-main":
          jQuery("#logo-main").addClass("opacity-0").removeClass("opacity-100");
          break;
        case "sp-main":
        case "sp-page":
        case "sp-porfolio-single-header":
          jQuery("#sp-title").removeClass("opacity-0").addClass("opacity-80");
          jQuery("#sp-dash")
            .removeClass("translate-x-full")
            .addClass("-translate-x-32");
          // jQuery("#sp-menu-desktop")
          //   .addClass("h-32")
          //   .removeClass("h-20")
          //   .find(".sp-menu-desktop-bg")
          //   .removeClass("opacity-80")
          //   .addClass("opacity-0");
          // jQuery("#sp-menu")
          //   .addClass("-translate-y-full")
          //   .removeClass("translate-y-0");
          break;
        case "sp-process":
          jQuery(".path").removeClass("path-inactive").addClass("path-active");
          jQuery(".path-point")
            .removeClass("opacity-0")
            .addClass("opacity-100");
          jQuery(".path-point-text")
            .removeClass("opacity-0")
            .addClass("opacity-100");
          break;
        case "sp-home":
          jQuery(".nav-mobile").addClass("").removeClass("bg-black opacity-80");
          //console.log("nasze_miody in");
          break;
        default:
          jQuery(entry.target) //"#" + entry.target.id + " .growing-line")
            .addClass("w-full")
            .removeClass("w-0");
      }
    } else {
      switch (entry.target.id) {
        case "logo-main":
          jQuery("#logo-main").addClass("opacity-80").removeClass("opacity-0");
          break;
        case "sp-main":
        case "sp-page":
        case "sp-porfolio-single-header":
          jQuery("#sp-title").removeClass("translate-x-full opacity-0");
          // jQuery("#sp-menu-desktop")
          //   .addClass("h-20")
          //   .removeClass("h-32")
          //   .find(".sp-menu-desktop-bg")
          //   .removeClass("opacity-0")
          //   .addClass("opacity-80");
          //   jQuery("#sp-menu")
          //     .addClass("translate-y-0")
          //     .removeClass("-translate-y-full");
          break;
        case "sp-process":
          jQuery(".path").removeClass("path-active").addClass("path-inactive");
          break;
          break;
        case "sp-home":
          jQuery(".nav-mobile").addClass("bg-black opacity-80").removeClass("");

          //console.log("nasze_miody out");
          break;
        default:
          jQuery(entry.target) //"#" + entry.target.id + " .growing-line")
            .addClass("w-0")
            .removeClass("w-full");
      }
    }

    // Each entry describes an intersection change for one observed
    // target element:
    //   entry.boundingClientRect
    //   entry.intersectionRatio
    //   entry.intersectionRect
    //   entry.isIntersecting
    //   entry.rootBounds
    //   entry.target
    //   entry.time
  });
};

let callbackFast = (entries, observer) => {
  entries.forEach((entry) => {
    //console.log("callback;", entry.target);
    if (entry.isIntersecting) {
      switch (entry.target.id) {
        case "sp-main":
        case "sp-page":
        case "sp-porfolio-single-header":
          jQuery("#sp-menu-desktop")
            .addClass("h-32")
            .removeClass("h-20")
            .find(".sp-menu-desktop-bg")
            .removeClass("opacity-80")
            .addClass("opacity-0");

          break;
      }
    } else {
      switch (entry.target.id) {
        case "sp-main":
        case "sp-page":
        case "sp-porfolio-single-header":
          jQuery("#sp-menu-desktop")
            .addClass("h-20")
            .removeClass("h-32")
            .find(".sp-menu-desktop-bg")
            .removeClass("opacity-0")
            .addClass("opacity-80");
          break;
      }
    }
  });
};

const sp_add_to_cart = (event) => {
  console.log(event.currentTarget.dataset.productid);
  // console.log(
  //   "sp_add_to_cart:",
  //   jQuery(".sp-add-to-cart").data("productid")
  // );
  //alert("clicked");
  sp_AddToCart(event.currentTarget.dataset.productid);
};

function sp_AddToCart(product_id, quantity = 1) {
  // let's check is add-to-cart.min.js is enqueued and parameters are presented
  if ("undefined" === typeof wc_add_to_cart_params) {
    return false;
  }

  jQuery.post(
    wc_add_to_cart_params.wc_ajax_url
      .toString()
      .replace("%%endpoint%%", "add_to_cart"),
    {
      product_id: product_id,
      quantity: quantity, // quantity is hardcoced her
    },
    function (response) {
      if (!response) {
        return;
      }
      // redirect is optional and it depends on what is set in WooCommerce configuration
      if (response.error && response.product_url) {
        console.log("sp_AddToCart, response:", response.error);
        //window.location = response.product_url;
        return;
      }
      console.log(response);
      if ("yes" === wc_add_to_cart_params.cart_redirect_after_add) {
        window.location = wc_add_to_cart_params.cart_url;
        return;
      }
      //reload instead of adjusting cart with event becasue in 9.3.1 it stopped working
      window.location.reload();

      // refresh cart fragments etc
      jQuery(document.body).trigger("added_to_cart", [
        response.fragments,
        response.cart_hash,
      ]);
      jQuery(".wc-block-mini-cart__button").addClass("animate-bounce");
    }
  );
}
